import React from 'react';

import { IconButton, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  KeyboardArrowDown,
  KeyboardArrowUpOutlined,
} from '@mui/icons-material';

interface Props {
  headerKeys: string[];
  omitEdit?: boolean;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}

export default function TableHeader({
  headerKeys,
  omitEdit,
  open,
  setOpen,
}: Props) {
  const { t } = useTranslation(undefined, { keyPrefix: 'ghg.tableV2.headers' });
  const width = `${Math.floor(100 / headerKeys.length)}%`;
  return (
    <TableHead>
      <TableRow>
        {open !== undefined && (
          <TableCell width="0%">
            <IconButton size="small" onClick={() => setOpen?.(!open)}>
              {open ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDown />}
            </IconButton>
          </TableCell>
        )}
        {headerKeys.map((header) => (
          <TableCell key={header} width={width} sx={{ ml: '6px' }}>
            {t(header)}
          </TableCell>
        ))}
        {!omitEdit && (
          <TableCell sx={{ ml: '6px' }}>{t('editOptions')}</TableCell>
        )}
      </TableRow>
    </TableHead>
  );
}
